import { rbacStore } from "../rbacStore"

export const useRbacStore = () => {
  const roles = rbacStore((state) => state.roles)
  const permissions = rbacStore((state) => state.permissions)
  const loadingRoles = rbacStore((state) => state.loadingRoles)
  const loadingPermissions = rbacStore((state) => state.loadingPermissions)
  const rolesError = rbacStore((state) => state.rolesError)
  const permissionsError = rbacStore((state) => state.permissionsError)

  const getRoles = rbacStore((state) => state.getRoles)
  const getPermissions = rbacStore((state) => state.getPermissions)
  const clearRbac = rbacStore((state) => state.clearRbac)

  return {
    roles,
    permissions,
    loadingRoles,
    loadingPermissions,
    rolesError,
    permissionsError,
    getRoles,
    getPermissions,
    clearRbac,
  }
}

export default useRbacStore
